<template>
  <div class="page">
    <img :src="$getImage(`onesti-logo/onesti-logo-branco-${currentLocale}.svg`)" class="logo" :alt="`${$t('alt.logo')} Onesti`" @click="goToMainPage">
    <div class="code">
      404
    </div>
    <p class="code-message">
      {{ $t('notFound.codeMessage') }}
    </p>
    <p class="main-phrase">
      {{ $t('notFound.mainPhrase') }}
    </p>
    <div class="go-back-text">
      <p v-for="paragraph in $t('notFound.goBackText')" class="mt-1">
        {{ paragraph }}
      </p>
    </div>
    <button class="btn" @click="goToMainPage">
      {{ $t('notFound.link') }}
    </button>
    <div class="contact">
      <p class="contact__title">
        {{ $t('notFound.contact.text') }}
      </p>
      <p class="contact__email">
        {{ $t('notFound.contact.email') }}
      </p>
      <p class="contact__phone">
        {{ $t('notFound.contact.phone') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    goToMainPage () {
      this.$router.push({
        name: 'home-lang',
        params: {
          lang: this.currentLocale
        }
      })
    }
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.logo
  @apply cursor-pointer w-32
  @screen md
    @apply absolute w-48
    top: 2rem
    right: 2rem

.page
  @apply flex flex-col items-center bg-pink text-white min-h-screen p-2
  @screen md
    @apply pt-5

.code
  @apply font-condensed
  font-size: 8rem
  @screen xl
    font-size: 10rem

.code-message
  @apply text-lg font-thin
  @screen md
    @apply text-2xl w-112

.main-phrase
  @apply text-2xl font-thin my-3
  @screen md
    @apply text-5xl my-5
  @screen xl
    font-size: 4rem
  @screen xxl
    font-size: 6rem

.go-back-text
  @apply text-lg font-thin
  @screen md
    @apply text-2xl

.btn
  @apply text-pink text-sm font-bold uppercase whitespace-no-wrap bg-white rounded shadow-md cursor-pointer px-2 py-1 mt-4
  @screen md
    @apply text-lg

.contact
  @apply text-center text-lg mt-4
  &__title
    @apply text-xl mb-1
  @screen md
    @apply absolute mt-0
    bottom: 2rem
    right: 2rem
</style>
